import React from 'react';
import TraceTileContextProvider from '@/finsight/application/Trace/TraceTileContext';
import FiltersContextProvider from '@/finsight/application/FiltersContext';
import TraceTableContextProvider from '@/finsight/application/Trace/TraceTableContext';
import TraceAssetClassesContextProvider from '@/finsight/application/Trace/TraceAssetClassesContext';
import { defaultTileFilterPayload } from './constants';

const ComposeTraceTileContext = ({ children, traceTileData }) => {
  const {
    filterPayload,
    enabled,
  } = traceTileData;
  const { ...baseParams } = defaultTileFilterPayload;
  return (
    <TraceAssetClassesContextProvider>
      <TraceTileContextProvider
        enabled={ enabled }
        filterPayload={ filterPayload }
      >
        <FiltersContextProvider initial={ { baseParams } }>
          <TraceTableContextProvider>
            { children }
          </TraceTableContextProvider>
        </FiltersContextProvider>
      </TraceTileContextProvider>
    </TraceAssetClassesContextProvider>
  );
};

export default ComposeTraceTileContext;
